export const homeContent = {
  searchPlaceholder: "Buscar productos, modelos o categorías...",
  heroTags: ["Con chip", "Genérico"],
  heroAction: "Ver producto",
  sectionAction: "Ver todo",
  allCategoriesAction: "Ver todas",
  allCategoriesShortcut: "Todas las categorías",
  featuredCategoriesTitle: "Categorías destacadas",
  trustHighlights: [
    "Envíos a toda Bolivia",
    "Pago contra entrega",
    "Pedidos por WhatsApp",
  ],
  popularProductsTitle: "Productos populares",
  whatsappLabel: "Consultar por WhatsApp",
  emptyCatalog: "No hay productos publicados para mostrar.",
  navItems: ["Inicio", "Categorías", "Carrito"],
  bottomNavItems: ["Inicio", "Categorías", "Ubicación", "Carrito"],
  productLabels: {
    unit: "Unitario",
    wholesale: "Mayor",
    wholesaleFrom: "Desde",
    units: "un.",
  },
} as const;
